
const ContentHeightSubject = (() => {
  var minHeight = 0;
  var contentHeightObserver;
  const contentHeightDidChange = () => {
    if(!contentHeightObserver){
      console.log('no `ContentHeight` observer found');
      return;
    }
    var body = document.body, html = document.documentElement;
    var height = 
      Math.max(
          minHeight
          ,body.scrollHeight
          ,body.offsetHeight
          ,html.clientHeight
          ,html.scrollHeight
          ,html.offsetHeight);
    console.log('contentHeightDidChange:',height);
    contentHeightObserver.postMessage({ "ContentHeight": height }, "*");       
  };

  const init = useMinHeight => {
    minHeight = useMinHeight;
    console.log('Awaiting ContentHeight observer');
    window.addEventListener('message', function (event) {
      /* When running this app in an <iframe>,
      ** it can be useful to know the height of the content *from the parent frame*.
      ** To receive the ContentHeight on every reactjs render (for accuracy):
        window.onload = () => {
          const iframe = document.querySelector('iframe');
          console.log('iframe',iframe);
          window.addEventListener('message', function (event) {
            if (!event.data.hasOwnProperty("ContentHeight")){
                return;
            }
            console.log('new iframe content height:', event.data.ContentHeight);
            iframe.style.height = event.data.ContentHeight + 'px';
          });
          iframe.contentWindow.postMessage('PleasePostContentHeight','*');
        };
      */
      if (event.data === "PleasePostContentHeight") {
        contentHeightObserver = event.source;
        contentHeightDidChange();
      }
    });
  };

  return { init, contentHeightDidChange };
})();

export default ContentHeightSubject;